import styled from '@emotion/styled';
import { TitleMedium } from '../../styles';
import { Box } from '@mui/material';

const InstitutionTableRow = styled(Box)`
    display: grid;
    grid-template-columns: 3fr 1fr;
    background-color: ${({ theme }) => theme.colors.surface};
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    padding: ${({ theme }) => theme.spacing(2)};
    cursor: pointer;
`;

const InstitutionTitleMedium = styled(TitleMedium)`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    color: ${({ theme }) => theme.colors.onPrimaryDark};
`;

export { InstitutionTableRow, InstitutionTitleMedium };
